import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { useExternalData } from "../../utils/ApiContext";
import { BASEURL } from "../../utils/Variables";
import RectangleSVG from "../../assets/images/Rectangle.svg"

const IMAGE_BASE_PATH = BASEURL;
const DATA_FILE_PATH = "/uploads/data.json";
const BG_SHAPE_FILENAME = RectangleSVG;

const slugify = (text) => {
    return text
        .toLowerCase()
        .trim()
        .replace(/&/g, 'and')
        .replace(/[^\w\s-]/g, '')
        .replace(/[\s_-]+/g, '-')
        .replace(/^-+|-+$/g, '');
};

const unslugifyAndCapitalize = (slug) => {
    const words = slug.split('-');
    const capitalized = words.map(word => {
        if (word === 'and') return '&';
        return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');

    if (capitalized.includes(' & ')) {
        return capitalized.replace(' & ', ' & ');
    }
    return capitalized;
};


export default function IndustryPage() {
    const { industrySlug } = useParams();
    const [data, setData] = useState({ brands: [], industries: [], Playables: [] });
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const { apiData, loading, apiError } = useExternalData()
    const [industryCheck,setIndustryCheck] = useState(null);

    useEffect(() => {
        // if(loading) setIsLoading(false);
        // if(apiError) setError(apiError);
        if(apiData) setData(apiData)
    },[apiData])
    
    // useEffect(() => {
    //     fetch(DATA_FILE_PATH)
    //         .then(response => {
    //             if (!response.ok) {
    //                 throw new Error(`Failed to fetch data: ${response.statusText}`);
    //             }
    //             return response.json();
    //         })
    //         .then(fetchedData => {
    //             setData(fetchedData);
    //         })
    //         .catch(err => {
    //             setError(err.message);
    //         })
    //         .finally(() => {
    //             setIsLoading(false);
    //         });
    // }, []);

    // const industryName = unslugifyAndCapitalize(industrySlug);

    // const filteredBrands = data.brands.filter(
    //     (brand) => brand.industryId.name === industryName
    // );
    // console.log("filteredBrands1",filteredBrands);

   const industryName = unslugifyAndCapitalize(industrySlug);

    const rawIndustryBrands = (data.brands || []).filter(
        (brand) => brand.industryId?.name === industryName
    );

    const activeBrandIds = new Set(
        (data.staticPlayables || [])
            .map((playable) => playable.brandId?._id)
            .filter(Boolean)
    );

    const filteredBrands = rawIndustryBrands.filter((brand) =>
        activeBrandIds.has(brand._id)
    );
//         {
//     "_id": "6a500bc13fcd0bee4b9823c0",
//     "name": "Catch The Coke",
//     "brandId": {
//         "_id": "6a500657fbd1922f5bd3e23b",
//         "name": "Cocacola"
//     },
//     "industryID": {
//         "_id": "6a500454fbd1922f5bd3e239",
//         "name": "Food & Beverages"
//     },
//     "gameCategoryId": {
//         "_id": "6a5004c7fbd1922f5bd3e23a",
//         "name": "Custom Games"
//     },
//     "thumbnailFileName": "catchthecoke.webp",
//     "playableLink": "https://cocokchsrity.pages.dev/",
//     "title": "Catch the Coke!",
//     "description": "Loram30",
//     "howToPlay": {
//         "step1": "Tap the “Play Now” button to begin the game",
//         "step2": "Slide Santa left or right using your finger on the sliding bar below to collect falling gifts.",
//         "step3": "Fill the bag with as many gifts as possible before the 30-second timer runs out to share the holiday magic."
//     },
//     "brandDescription": "This isn’t just a game - it’s holiday magic in action. Every round helps support meals for kids through No Kid Hungry. Collect gifts fast and help spread joy, one swipe at a time",
//     "playableCategory": "Branding",
//     "status": 1,
//     "uberSiteStatus": 1,
//     "iopexSiteStatus": 1,
//     "thumbnailPath": "/uploads/images/staticPlayable/thumbnail/catchthecoke.webp",
//     "cby": "6a4fef60701262d3bad5fd70",
//     "createdAt": "2026-07-09T20:59:45.919Z",
//     "updatedAt": "2026-07-24T15:47:52.988Z",
//     "__v": 0
// }

    
    

    const industryInfo = data.industries.find(
        (industry) => industry.name === industryName
    );

    const isGeneric = industryInfo?.description === "Loram Ipusam 15";
    const headerDescription = (!isGeneric && industryInfo)
        ? industryInfo.description
        : (filteredBrands.length > 0 ? filteredBrands[0].description : `Explore the top brands in the ${industryName} sector.`);

    const bannerImage = industryInfo ? `${IMAGE_BASE_PATH}${industryInfo.industryBannerPath}` : "";
console.log("bannerImage1",bannerImage);

    if (isLoading) {
        return <p className="text-center p-10">Loading brands...</p>;
    }

    if (error) {
        return <p className="text-center p-10 text-red-600">Error loading data: {error}</p>;
    }

const bgShapePath = BG_SHAPE_FILENAME;

    return (
        <div className="bg-black min-h-screen">

            <section className="relative w-full overflow-hidden bg-black">
                <div className="flex flex-col xl-custom:hidden">
                    <div className="relative w-full overflow-hidden">
                        <img
                            src={bannerImage}
                            
                            alt={`${industryName} Visual`}
                            className="w-full h-auto object-contain"
                        />
                    </div>
                    <div className="px-4 py-8 text-white text-left">
                        <h1 className="font-uber text-[28px] font-bold leading-[36px] sm:text-[32px] sm:leading-[40px]">
                            {industryName}
                        </h1>
                        <p className="mt-2 text-current font-uber text-[16px] font-normal leading-[24px] max-w-md">
                            {industryInfo ? industryInfo.shortTitle : 'Discover our featured brands.'}
                        </p>
                    </div>
                </div>

                <div className="relative w-full  hidden xl-custom:flex xl-custom:items-center" style={{ minHeight: '60vh' }}>
                    <img
                        src={bannerImage}
                        alt={`${industryName} Visual`}
                        className="absolute inset-0 w-full h-full object-contain z-0"
                        style={{ paddingLeft: '5%' }}
                    />

                    <div className="relative z-10 mx-auto max-w-6xl px-6 py-14 w-full">
                        <div className="w-full md:w-5/12 text-white text-center md:text-left">
                            <h1 className="font-uber text-[28px] font-bold leading-[36px] sm:text-[32px] sm:leading-[40px] xl-custom:text-[36px] xl-custom:leading-[44px]">
                                {industryName}
                            </h1>
                            <p className="mt-2 text-current font-uber text-[16px] font-normal leading-[24px] max-w-md">
                                {industryInfo ? industryInfo.shortTitle : 'Discover our featured brands.'}
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="relative w-full overflow-hidden bg-gray-50">
                <div className="mx-auto max-w-6xl px-4 p-14 sm:px-6">
                    <div className="mb-12">
                        <p className="font-uber text-[28px] font-bold leading-[36px] sm:text-[32px] sm:leading-[40px] xl-custom:text-[36px] xl-custom:leading-[44px] text-center max-w-4xl mx-auto text-gray-800">
                            {headerDescription}
                        </p>
                    </div>

                    {filteredBrands.length === 0 && (
                        <p className="text-center text-xl text-gray-500">
                            No brands found for the {industryName} industry.
                        </p>
                    )}

                    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6">
                        {filteredBrands.map((brandItem, index) => {
                            const brandName = brandItem.name;
                            const brandID = brandItem._id;
                            const brandSlug = slugify(brandName);

                            const linkTo = `/industries/${industrySlug}/${brandSlug}`;
                            console.log("linkTo",linkTo);
                            
                            const brandLogoPath = IMAGE_BASE_PATH + brandItem.brandLogoPath;
                            const brandLogoPath1 = IMAGE_BASE_PATH + brandItem.brandLogoPath;

                            return (
                                <Link
                                    to={linkTo}
                                    key={index}
                                    className="relative rounded-lg shadow-lg w-full max-w-[240px] h-[140px] overflow-hidden group hover:shadow-xl transition-shadow"
                                >
                                    <img
                                        src={bgShapePath}
                                        alt="Card background shape"
                                        className="absolute inset-0 w-full h-full object-cover rounded-lg"
                                    />
                                    <div className="relative z-10 w-full h-full flex items-center justify-center p-4">
                                        <img
                                            // src={brandID == "B45" ? brandLogoPath1 : brandLogoPath}
                                            src={brandID == "B45" ? brandLogoPath1 : brandLogoPath}
                                            alt={brandName}
                                            className="w-20 h-20 object-contain"
                                            onError={(e) => {
                                                e.target.style.display = 'none';
                                                e.target.parentNode.innerHTML = '<span style="color:red; font-size:12px;">LOGO FAIL</span>';
                                            }}
                                        />
                                    </div>
                                </Link>
                            );
                        })}
                    </div>
                </div>
            </section>
        </div>
    );
}